export const title = "Contact";
export const email = "tarikmerryface@gmail.com"
export const socialMediaUrl = [
  {
  id: 0,
    name: "youtube",
    url: "https://www.youtube.com/channel/UCjkotIU0LsTjMTkYap6cjvw",
  },
  {
    id: 1,
    name: "facebook",
    url: "https://www.facebook.com/AviateNavigateCommunicateAcademy/",
  },
  {
    id: 2,
    name: "instagram",
    url: "https://www.instagram.com/a.n.c_academy/",
  },
]